import {makeAutoObservable} from "mobx";
import {PicklistFilterLastScanStatus, PicklistOverviewListItemDto} from "../../api/fms";
import {pageLoadingStore} from "../PageLoadingStore";
import {api, catchApi} from "../../api";

class FmsPicklistOverviewStore {
    get scanStatus(): string | undefined {
        return this._scanStatus;
    }

    set scanStatus(value: string | undefined) {
        this._scanStatus = value;
    }

    get size(): number {
        return this._size;
    }

    set size(value: number) {
        this._size = value;
    }

    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
    }

    get pages(): number {
        return this._pages;
    }

    set pages(value: number) {
        this._pages = value;
    }

    get items(): PicklistOverviewListItemDto[] {
        return this._items;
    }

    set items(value: PicklistOverviewListItemDto[]) {
        this._items = value;
    }

    get toAbsolute(): string | undefined {
        return this._toAbsolute;
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value;
    }

    get fromAbsolute(): string | undefined {
        return this._fromAbsolute;
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }

    get toRelative(): string | undefined {
        return this._toRelative;
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value;
    }

    get fromRelative(): string | undefined {
        return this._fromRelative;
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }

    private _items: PicklistOverviewListItemDto[] = []
    private _pages: number = 0
    private _page: number = 1
    private _size: number = 25
    private _fromRelative?: string
    private _toRelative?: string
    private _fromAbsolute?: string
    private _toAbsolute?: string
    private _scanStatus?: string

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        pageLoadingStore.loading = true
        const {
            scanStatus,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute
        } = this

        const result = await catchApi(async () => await api.fms.api.listPicklists({
            page: this.page - 1,
            size: this.size,
            lastScanStatus: scanStatus as PicklistFilterLastScanStatus || undefined,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
        }))
        const data = result?.data
        if (data?.items) {
            this.items = data.items
            this.pages = data.totalPages || 0
        } else {
            this.items = []
            this.pages = 0
        }
        pageLoadingStore.loading = false
    }
}

const fmsPicklistOverviewStore = new FmsPicklistOverviewStore()

export {
    fmsPicklistOverviewStore
}
